<template>
  <div
    id="main-grid"
    class="grid simple main borderRadius12px"
    style="background: #e5e9ec"
  >
    <div class="well form-group" style="background: #e5e9ec">
      <!-- title -->
      <div class="grid-title no-border borderTop">
        <h4 style="padding-left: 6px">{{ i18nValues["fieldEdition"] }}</h4>
      </div>

      <!-- form -->
      <div class="grid-body no-border borderBottom">
        <el-form
          v-loading="loading != 0"
          :model="field"
          ref="formField"
          :rules="rules"
        >
          <div class="gridTemplate">
            <!-- Name -->
            <el-form-item :label="i18nValues['name']" prop="name">
              <el-input v-model="field.name" maxlength="30"></el-input>
            </el-form-item>

            <!-- Location -->
            <el-form-item :label="i18nValues['coordenates']" prop="location">
              <el-input
                v-model="field.location"
                @input="validateFieldLocationInput"
              ></el-input>
            </el-form-item>

            <!-- Producer -->
            <el-form-item :label="i18nValues['producer']" prop="producer">
              <el-select
                v-model="field.producer.id"
                placeholder="Please select"
                filterable
              >
                <el-option
                  v-for="item in ProducersList"
                  :key="item.id"
                  :label="item.businessName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <!-- City -->
            <el-form-item :label="i18nValues['city']" prop="city">
              <el-input v-model="field.city"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
          <el-button
            v-if="!isReadOnly()"
            @click="addFieldLot()"
            icon="fas fa-plus"
            size="small"
            class="btn-primary"
          >
            {{ i18nValues["addFieldLot"] }}
          </el-button>
        </div>

        <!-- table and map container -->
        <div class="table-map-container">
          <!-- table -->
          <div class="table-wrapper">
            <el-table
              v-if="fieldLotsList.length > 0"
              :data="fieldLotsList"
              class="table table-hover table-striped"
              id="itemsTable"
              :empty-text="i18nValues['noDataAvailable']"
              align="left"
            >
              <!-- FieldLots Name -->
              <el-table-column
                prop="name"
                :label="i18nValues['name']"
                width="75"
                align="center"
              ></el-table-column>

              <!-- FieldLots Dimension -->
              <el-table-column
                prop="dimensions"
                :label="i18nValues['dimension']"
                width="75"
                align="center"
              ></el-table-column>

              <!-- EDIT & REMOVE -->
              <el-table-column width="130" align="right">
                <template slot-scope="scope">

                  <el-button
                    v-if="!isReadOnly()"
                    class="text-info"
                    icon="fas fa-edit"
                    size="small"
                    :title="i18nValues['edit']"
                    @click="editBoundary(scope.row, scope.$index)"
                  ></el-button>

                  <el-button
                    v-if="!isReadOnly()"
                    class="text-danger"
                    icon="fas fa-times"
                    size="small"
                    :title="i18nValues['remove']"
                    @click="removeFieldLot(scope.row)"
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- map on the right -->
          <div class="map-wrapper">
            <Map
              v-if="renderMap"
              v-show="!isBoundaryDialogOpen"
              :key="mapKey"
              mapId="main-map"
              :field="field"
              :fieldLot="fieldLot"
              :fieldLotsList="fieldLotsList"
              :showMarkers="false"
              class="compact-map"
            ></Map>
          </div>
        </div>

        <!-- CANCEL/SAVE -->
        <div class="full-width d-flex justify-content-end mt-2">
          <el-button
            :loading="loading"
            size="small"
            @click="cancel()"
          >
            {{ i18nValues["cancel"] }}
          </el-button>
          <el-button
            v-if="!isReadOnly()"
            icon="fas fa-check"
            :loading="loading"
            size="small"
            class="btn-primary"
            @click="save()"
          >
            {{ i18nValues["save"] }}
          </el-button>
        </div>
      </div>
    </div>

    <el-dialog
      :title="
        (boundaryEditingIndex >= 0 
          ? (i18nValues['editFieldLot'] || 'Edit Field Lot')
          : (i18nValues['addFieldLot'] || 'Add Field Lot')) +
        (boundaryEditingLotName ? ` - ${boundaryEditingLotName}` : '')
      "
      :visible.sync="isBoundaryDialogOpen"
      width="90%"
      @close="closeBoundaryDialog"
      @opened="onBoundaryDialogOpened"
      class="boundary-dialog-modal"
    >
      <div class="boundary-dialog-content">
        <div class="boundary-dialog-left">
          <div class="boundary-dialog-inputs-section">
            <div class="boundary-dialog-row">
              <span class="boundary-dialog-label">{{ i18nValues['name'] || 'Name' }}</span>
              <el-input
                size="small"
                v-model="boundaryEditingLot.name"
                :maxlength="30"
              ></el-input>
            </div>

            <div class="boundary-dialog-row">
              <span class="boundary-dialog-label">{{ i18nValues['dimension'] || 'Dimension (Has)' }}</span>
              <el-input
                size="small"
                v-model="boundaryEditingLot.dimensions"
                type="number"
                :placeholder="(i18nValues['dimension'] || 'Dimension') + ' (Has)'"
                :maxlength="30"
              ></el-input>
            </div>

            <div v-if="boundaryDraftError" class="text-danger boundary-dialog-error">
              {{ boundaryDraftError }}
            </div>

            <div class="boundary-dialog-actions">
              <el-button
                size="small"
                :type="isDrawingMode ? 'success' : 'default'"
                icon="el-icon-edit"
                @click="toggleDrawingMode"
                style="width: 100%;"
              >
                {{ isDrawingMode
                  ? (i18nValues['stopDrawing'] || 'Stop Drawing')
                  : (i18nValues['drawOnMap'] || 'Draw on Map')
                }}
              </el-button>
              <el-upload
                action=""
                :auto-upload="false"
                :show-file-list="false"
                :on-change="onBoundaryFileSelected"
                accept=".geojson,.json,.kml,.kmz"
                style="margin-top: 8px; width: 100%;"
              >
                <el-button
                  size="small"
                  icon="el-icon-upload"
                  style="width: 100%;"
                >
                  {{ i18nValues['uploadKML'] || 'Upload KML' }}
                </el-button>
              </el-upload>
            </div>
          </div>
        </div>
        <div class="boundary-dialog-right">
          <div v-if="!renderMap" style="height: 500px; display: flex; align-items: center; justify-content: center; color: #999;">
            Loading map...
          </div>
          <Map
            v-if="isBoundaryDialogOpen && renderMap"
            ref="boundaryMap"
            :key="'boundary-map-' + mapKey"
            mapId="boundary-map"
            :field="field"
            :fieldLot="boundaryEditingLot"
            :fieldLotsList="fieldLotsList"
            :enableDrawing="isDrawingMode"
            :showMarkers="false"
            @polygon-drawn="handlePolygonDrawn"
            style="width: 100% !important;height: 500px !important;"
          ></Map>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeBoundaryDialog">
          {{ i18nValues['cancel'] || 'Cancel' }}
        </el-button>
        <el-button
          size="small"
          type="primary"
          :disabled="!!boundaryDraftError"
          @click="confirmBoundaryDialog"
        >
          {{ i18nValues['save'] || 'Save' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
import Map from "@/components/map/Map.vue";
export default {
  name: "FieldEdition",

  created() {
    if (this.id != 0) {
      this.retrieveById();
    } else {
      this.field.creationUser = this.user.name;
      this.field.creationDate = new Date();
    }

    this.rules = {
      name: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      location: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      producer: [
        {
          validator: (rule, value, callback) => {
            if (!value || !value.id) {
              callback(new Error(this.i18nValues["requiredValue"]));
            } else {
              callback();
            }
          },
          trigger: "blur",
        },
      ],
    };


    this.retrieveProducers();
    // Capture initial query to preserve filters/pagination when returning once
    if (!this.returnQuery || Object.keys(this.returnQuery).length === 0) {
      this.returnQuery = { ...this.$route.query };
    }
  },

  components: {
    Map,
  },

  computed: {
    loading: get("field/loading"),
  },

  props: ["id"],

  data() {
    return {
      renderMap: false,
      mapKey: 0,
      field: {
        producer: {},
      },
      fieldLot: {
        name: "",
        location: "",
        dimensions: "",
        boundary: [],
        boundaryGeometry: "",
        boundaryFormat: "geojson",
      },
      fieldLotsList: [],
      rules: {},
      ProducersList: [],
      returnQuery: {},
      isBoundaryDialogOpen: false,
      boundaryEditingLotName: "",
      boundaryEditingIndex: -1,
      boundaryEditingLot: {
        name: "",
        location: "",
        dimensions: "",
        boundary: [],
        boundaryGeometry: "",
        boundaryFormat: "geojson",
      },
      boundaryDraftInputs: ["", "", "", ""],
      boundaryDraftError: "",
      boundaryDraft: [],
      boundaryOriginal: [],
      isDrawingMode: false,
      savedGeometryBeforeDrawing: null, // Store geometry before starting to draw
      savedFormatBeforeDrawing: null,
      newDrawingCompleted: false, // Track if new drawing was completed
    };
  },

  methods: {
    // Helper method to normalize dimensions: convert empty strings to null
    normalizeDimension(value) {
      if (value === null || value === undefined) {
        return null;
      }
      const str = String(value).trim();
      return str === "" ? null : str;
    },

    save() {
      this.$refs["formField"].validate((valid) => {
        if (valid) {
          // Normalize empty dimensions to null before saving
          this.field.fieldLots = this.fieldLotsList.map(lot => ({
            ...lot,
            dimensions: this.normalizeDimension(lot.dimensions)
          }));
          this.$store.dispatch("field/saveField", this.field).then((res) => {
            if (res.status == "OK") {
              this.$notify.success({
                title: this.i18nValues["succes"],
                message: this.i18nValues["saveField"],
                position: "bottom-right",
              });
              this.$router.push({ name: "FieldAdmin", query: this.returnQuery });
            } else {
              this.$notify.error({
                title: this.i18nValues["error"],
                message: this.i18nValues["saveFieldError"],
                position: "bottom-right",
              });
            }
          });
        }
      });
    },

    cancel() {
      this.$router.push({ name: "FieldAdmin", query: this.returnQuery });
    },

    retrieveById() {
      this.$store
        .dispatch("field/retrieveFieldById", { id: this.id })
        .then((res) => {
          this.field = res;
          this.field.modificationUser = this.user.name;
          this.field.modificationDate = new Date();
          this.fieldLotsList = this.field.fieldLots;
          this.renderMap = true;
          //console.log(this.field);//eslint-disable-line
        });
    },

    addFieldLot() {
      // Open the boundary dialog to add a new FieldLot
      this.boundaryEditingIndex = -1; // -1 means creating new
      this.boundaryEditingLotName = "";
      // Initialize with empty values for new FieldLot
      this.boundaryEditingLot = {
        name: "",
        location: "",
        dimensions: "",
        boundary: [],
        boundaryGeometry: "",
        boundaryFormat: "geojson",
      };
      this.boundaryOriginal = [];
      this.boundaryDraftError = "";
      this.isBoundaryDialogOpen = true;
      if (!this.renderMap) {
        this.renderMap = true;
      }
    },


    editBoundary(row, index) {
      const lotIndex = typeof index === "number" ? index : this.fieldLotsList.indexOf(row);
      this.boundaryEditingIndex = lotIndex;
      this.boundaryEditingLotName = row.name || "";
      // Set boundaryEditingLot to the row being edited so Name and Dimension inputs show current values
      // Location now represents the full polygon geometry (boundaryGeometry)
      // If location exists and looks like geometry, use it; otherwise fall back to boundaryGeometry
      const locationValue = row.location || row.boundaryGeometry || "";
      this.boundaryEditingLot = JSON.parse(JSON.stringify({
        name: row.name || "",
        location: locationValue,
        dimensions: row.dimensions || "",
        boundary: row.boundary || [],
        boundaryGeometry: row.boundaryGeometry || locationValue,
        boundaryFormat: row.boundaryFormat || "geojson",
      }));
      this.boundaryOriginal = JSON.parse(
        JSON.stringify(row.boundary || [])
      );

      this.boundaryDraftError = "";
      this.isBoundaryDialogOpen = true;
      if (!this.renderMap) {
        this.renderMap = true;
      }
    },

    onBoundaryDialogOpened() {
      if (!this.renderMap) {
        this.renderMap = true;
      }
      this.$nextTick(() => {
        this.mapKey += 1;
        const m = this.$refs.boundaryMap;
        if (m && this.boundaryEditingLot) {
          // Location now represents the full polygon geometry
          const geometryString = this.boundaryEditingLot.location || this.boundaryEditingLot.boundaryGeometry;
          // Only load geometry if it exists (for editing existing FieldLot)
          // For new FieldLot, the map will be empty
          if (geometryString) {
            // Detect format from the string
            let format = this.boundaryEditingLot.boundaryFormat || "geojson";
            if (!format || format === "geojson") {
              // Try to detect if it's KML
              if (typeof geometryString === "string" && (geometryString.includes("<kml") || geometryString.includes("<?xml"))) {
                format = "kml";
              } else {
                format = "geojson";
              }
            }
            m.loadGeometryString(format, geometryString);
          }
        }
      });
    },

    onBoundaryInputChange(index, value) {
      if (index >= 0 && index < 4) {
        this.boundaryDraftInputs[index] = value;
        this.handleBoundaryDraftInputs();
      }
    },

    handleBoundaryDraftInputs() {
      const boundary = [];
      const invalidIndexes = [];

      this.boundaryDraftInputs.forEach((input, index) => {
        const trimmed = (input || "").trim();
        
        if (!trimmed) {
          invalidIndexes.push(index + 1);
          return;
        }

        const parts = trimmed.split(/[\s,]+/).filter((item) => item !== "");
        if (parts.length < 2) {
          invalidIndexes.push(index + 1);
          return;
        }

        const lat = parseFloat(parts[0].replace(",", "."));
        const lon = parseFloat(parts[1].replace(",", "."));

        if (!isFinite(lat) || !isFinite(lon)) {
          invalidIndexes.push(index + 1);
          return;
        }

        boundary.push([lat, lon]);
      });

      if (invalidIndexes.length > 0) {
        this.boundaryDraftError =
          this.i18nValues["boundaryInvalid"] ||
          "Invalid coordinates";
        this.boundaryDraft = [];
        return;
      }

      if (boundary.length !== 4) {
        this.boundaryDraftError =
          this.i18nValues["boundaryRequired"] ||
          "All four coordinates are required.";
        this.boundaryDraft = [];
        return;
      }

      const first = boundary[0];
      const last = boundary[boundary.length - 1];
      if (first[0] !== last[0] || first[1] !== last[1]) {
        boundary.push([first[0], first[1]]);
      }

      this.boundaryDraft = boundary;
      this.boundaryDraftError = "";
    },

    confirmBoundaryDialog() {
      if (this.boundaryDraftError) {
        return;
      }

      // Validate name is provided
      if (!this.boundaryEditingLot.name || !this.boundaryEditingLot.name.trim()) {
        this.boundaryDraftError = this.i18nValues["requiredValue"] || "Name is required";
        return;
      }

      const index = this.boundaryEditingIndex;
      
      if (index >= 0 && index < this.fieldLotsList.length) {
        // Editing existing FieldLot
        const updatedLot = JSON.parse(
          JSON.stringify(this.fieldLotsList[index])
        );
        // Save Name and Dimension from boundaryEditingLot inputs
        updatedLot.name = this.boundaryEditingLot.name || updatedLot.name;
        const normalizedNewDimension = this.normalizeDimension(this.boundaryEditingLot.dimensions);
        updatedLot.dimensions = normalizedNewDimension !== null ? normalizedNewDimension : this.normalizeDimension(updatedLot.dimensions);
        // Persist geometry string + format if available (preferred)
        if (this.boundaryEditingLot.boundaryGeometry) {
          updatedLot.boundaryGeometry = this.boundaryEditingLot.boundaryGeometry;
          updatedLot.boundaryFormat = this.boundaryEditingLot.boundaryFormat || "geojson";
        }
        // Set location to boundaryGeometry (location now represents full polygon)
        if (this.boundaryEditingLot.location) {
          updatedLot.location = this.boundaryEditingLot.location;
        } else if (this.boundaryEditingLot.boundaryGeometry) {
          updatedLot.location = this.boundaryEditingLot.boundaryGeometry;
        }
        // Maintain legacy boundary array if present
        if (Array.isArray(this.boundaryDraft) && this.boundaryDraft.length) {
          updatedLot.boundary = JSON.parse(JSON.stringify(this.boundaryDraft));
        }

        this.$set(this.fieldLotsList, index, updatedLot);
        this.$set(this.field, "fieldLots", this.fieldLotsList);

        // eslint-disable-next-line no-console
        console.log("Boundary saved fieldLot:", updatedLot);
      } else {
        // Creating new FieldLot
        const newLot = {
          name: this.boundaryEditingLot.name,
          dimensions: this.normalizeDimension(this.boundaryEditingLot.dimensions),
          location: this.boundaryEditingLot.location || this.boundaryEditingLot.boundaryGeometry || "",
          boundary: Array.isArray(this.boundaryDraft) && this.boundaryDraft.length 
            ? JSON.parse(JSON.stringify(this.boundaryDraft))
            : [],
          boundaryGeometry: this.boundaryEditingLot.boundaryGeometry || "",
          boundaryFormat: this.boundaryEditingLot.boundaryFormat || "geojson",
        };

        this.fieldLotsList.push(newLot);
        this.$set(this.field, "fieldLots", this.fieldLotsList);
        this.mapKey += 1;

        // eslint-disable-next-line no-console
        console.log("New fieldLot added:", newLot);
      }

      this.closeBoundaryDialog();
    },

    closeBoundaryDialog() {
      this.clearDraftPolygon();
      // If drawing was active but not completed, restore old geometry before closing
      if (this.isDrawingMode && !this.newDrawingCompleted && this.savedGeometryBeforeDrawing) {
        this.boundaryEditingLot.location = this.savedGeometryBeforeDrawing;
        this.boundaryEditingLot.boundaryGeometry = this.savedGeometryBeforeDrawing;
        this.boundaryEditingLot.boundaryFormat = this.savedFormatBeforeDrawing || "geojson";
      }
      this.isBoundaryDialogOpen = false;
      this.isDrawingMode = false;
      this.boundaryDraftError = "";
      this.boundaryDraft = [];
      this.boundaryDraftInputs = ["", "", "", ""];
      this.boundaryOriginal = [];
      this.boundaryEditingIndex = -1;
      this.boundaryEditingLotName = "";
      // Reset saved geometry flags
      this.savedGeometryBeforeDrawing = null;
      this.savedFormatBeforeDrawing = null;
      this.newDrawingCompleted = false;
      // Reset boundaryEditingLot to prevent it from affecting main form
      this.boundaryEditingLot = {
        name: "",
        location: "",
        dimensions: "",
        boundary: [],
        boundaryGeometry: "",
        boundaryFormat: "geojson",
      };
      this.$nextTick(() => {
        if (this.renderMap) {
          this.mapKey += 1;
        }
      });
    },

    toggleDrawingMode() {
      if (this.isDrawingMode) {
        // Stopping drawing mode
        if (!this.newDrawingCompleted) {
          // No new drawing was completed, restore the old geometry
          if (this.savedGeometryBeforeDrawing) {
            this.boundaryEditingLot.location = this.savedGeometryBeforeDrawing;
            this.boundaryEditingLot.boundaryGeometry = this.savedGeometryBeforeDrawing;
            this.boundaryEditingLot.boundaryFormat = this.savedFormatBeforeDrawing || "geojson";
            
            // Reload the geometry on the map
            this.$nextTick(() => {
              const m = this.$refs.boundaryMap;
              if (m && m.loadGeometryString) {
                const format = this.savedFormatBeforeDrawing || "geojson";
                m.loadGeometryString(format, this.savedGeometryBeforeDrawing);
              }
            });
          }
        }
        // Reset flags
        this.savedGeometryBeforeDrawing = null;
        this.savedFormatBeforeDrawing = null;
        this.newDrawingCompleted = false;
        this.isDrawingMode = false;
      } else {
        // Starting drawing mode
        // Save current geometry before clearing
        const currentGeometry = this.boundaryEditingLot.location || this.boundaryEditingLot.boundaryGeometry;
        if (currentGeometry) {
          this.savedGeometryBeforeDrawing = currentGeometry;
          this.savedFormatBeforeDrawing = this.boundaryEditingLot.boundaryFormat || "geojson";
        } else {
          this.savedGeometryBeforeDrawing = null;
          this.savedFormatBeforeDrawing = null;
        }
        this.newDrawingCompleted = false;
        
        // Don't clear the current geometry - keep it visible while drawing
        // The new drawing will appear in green on top of the existing blue polygons
        
        this.isDrawingMode = true;
      }
    },

    handlePolygonDrawn(result) {
      if (result && result.success && (result.geojson || result.kml)) {
        if (result.geojson) {
          this.boundaryEditingLot.boundaryGeometry = result.geojson;
          this.boundaryEditingLot.boundaryFormat = "geojson";
          // Set location to the boundaryGeometry (now represents full polygon)
          this.boundaryEditingLot.location = result.geojson;
        } else if (result.kml) {
          this.boundaryEditingLot.boundaryGeometry = result.kml;
          this.boundaryEditingLot.boundaryFormat = "kml";
          // Set location to the boundaryGeometry (now represents full polygon)
          this.boundaryEditingLot.location = result.kml;
        }
        // Mark that a new drawing was completed
        this.newDrawingCompleted = true;
        this.isDrawingMode = false;
        this.boundaryDraftError = "";
        // Clear saved geometry since we're using the new one
        this.savedGeometryBeforeDrawing = null;
        this.savedFormatBeforeDrawing = null;
      } else if (result && result.message) {
        this.boundaryDraftError = result.message;
      } else {
        this.boundaryDraftError =
          this.i18nValues["boundaryRequired"] ||
          "Please draw a polygon on the map.";
      }
    },

    onBoundaryFileSelected(file) {
      const fileObj = file.raw || file;
      if (!fileObj) {
        this.boundaryDraftError = "Invalid file selected.";
        return;
      }

      const fileName = (fileObj.name || "").toLowerCase();
      const isKML = fileName.endsWith(".kml");
      const isKMZ = fileName.endsWith(".kmz");
      const isGeoJSON = fileName.endsWith(".geojson") || fileName.endsWith(".json");

      if (!isKML && !isGeoJSON && !isKMZ) {
        this.boundaryDraftError = "Unsupported file format. Please upload .geojson, .json, or .kml files.";
        return;
      }

      if (isKMZ) {
        this.boundaryDraftError = "KMZ files are not directly supported. Please extract the KML file from the KMZ archive and upload it.";
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const text = e.target.result;
          if (!text || typeof text !== "string") {
            this.boundaryDraftError = "Failed to read file content.";
            return;
          }

          const format = isKML ? "kml" : "geojson";
          
          // Validate the content by trying to parse it
          if (format === "geojson") {
            try {
              const parsed = JSON.parse(text);
              if (!parsed || (!parsed.type && !parsed.features && !parsed.geometry)) {
                throw new Error("Invalid GeoJSON structure");
              }
            } catch (parseError) {
              this.boundaryDraftError = "Invalid GeoJSON format. Please check the file.";
              // eslint-disable-next-line no-console
              console.error("GeoJSON parse error:", parseError);
              return;
            }
          } else if (format === "kml") {
            // Basic KML validation - check if it contains KML structure
            if (!text.includes("<kml") && !text.includes("<?xml")) {
              this.boundaryDraftError = "Invalid KML format. Please check the file.";
              // eslint-disable-next-line no-console
              console.error("KML validation failed - missing KML/XML structure");
              return;
            }
          }

          // Store the geometry string
          this.boundaryEditingLot.boundaryGeometry = text;
          this.boundaryEditingLot.boundaryFormat = format;
          // Set location to the boundaryGeometry (now represents full polygon)
          this.boundaryEditingLot.location = text;

          // Load and display on the map
          const mapRef = this.$refs.boundaryMap;
          if (mapRef && mapRef.loadGeometryString) {
            const success = mapRef.loadGeometryString(format, text);
            if (success) {
              this.boundaryDraftError = "";
              this.isDrawingMode = false;
            } else {
              this.boundaryDraftError = "Failed to load geometry from file. Please check the console for details.";
            }
          } else {
            this.boundaryDraftError = "Map not ready. Please try again.";
          }
        } catch (error) {
          this.boundaryDraftError = "Error processing file: " + (error.message || "Unknown error");
        }
      };

      reader.onerror = () => {
        this.boundaryDraftError = "Failed to read the file.";
      };

      reader.readAsText(fileObj);
    },
    
    clearDraftPolygon() {
      if (this.$refs.boundaryMap && this.$refs.boundaryMap.clearDraftPolygon) {
        this.$refs.boundaryMap.clearDraftPolygon();
      }
    },

    removeClosingCoordinate(boundary = []) {
      if (!Array.isArray(boundary)) {
        return [];
      }

      if (boundary.length > 1) {
        const first = boundary[0];
        const last = boundary[boundary.length - 1];
        if (
          first &&
          last &&
          first[0] === last[0] &&
          first[1] === last[1]
        ) {
          return boundary.slice(0, boundary.length - 1);
        }
      }

      return boundary.slice();
    },

    removeFieldLot(obj) {
      this.$confirm(
        "Está seguro que quiere eliminar el Lote?",
        "Eliminar Lote",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      ).then(() => {
        this.$store.dispatch("field/deleteFieldLot", obj.id).then((res) => {
          if (res.status == "OK") {
            this.fieldLotsList = this.fieldLotsList.filter(
              (fieldLot) => fieldLot != obj
            );
          } else {
            this.$notify.error({
              title: this.i18nValues["error"],
              message: res.statusDescription,
              position: "bottom-right",
            });
          }
        });
      });
    },

    retrieveProducers() {
      this.$store.dispatch("producer/retrieveProducers").then((res) => {
        this.ProducersList = res;
      });
    },

    validateFieldLocationInput(value) {
      const isValidInput = /^[\d.,+-]+$/;

      if (isValidInput.test(value)) {
        this.field.location = value;
      } else {
        this.field.location = this.field.location.replace(/[^0-9.,+-]/g, "");
      }
    },
  },
};
</script>

<style>
.boundary-dialog {
  padding: 0 8px;
}

.boundary-dialog-row {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding-left: 8px;
  padding-right: 8px;
}

.boundary-dialog-label {
  width: 110px;
  font-size: 13px;
  color: #606266;
  flex-shrink: 0;
  font-weight: 500;
}

.boundary-dialog-row .el-input {
  max-width: 100%;
  flex: 1;
  min-width: 0;
}

.boundary-dialog-error {
  margin-top: 12px;
  padding-left: 12px;
  font-size: 12px;
}

.boundary-dialog-actions {
  margin-top: 16px;
  padding-left: 12px;
  text-align: center;
}

.boundary-dialog-actions .el-button {
  width: 100% !important;
  display: block;
}

.boundary-dialog-actions .el-upload {
  width: 100%;
  display: block;
}

.boundary-dialog-modal .el-dialog {
  max-width: 1800px;
}

.boundary-dialog-modal .el-dialog__body {
  padding: 24px;
  overflow: visible;
}

.boundary-dialog-modal .el-dialog__footer {
  padding: 15px 24px;
  border-top: 1px solid #e4e7ed;
  margin-top: 20px;
}

.boundary-dialog-content {
  display: flex;
  gap: 30px;
  margin-bottom: 20px;
}

.boundary-dialog-left {
  flex: 0 0 380px;
  min-width: 380px;
}

.boundary-dialog-right {
  flex: 1;
  min-width: 0;
  min-height: 500px;
  margin-left: 10px;
  margin-right: 12px;
}

.boundary-dialog-inputs-section {
  padding-right: 20px;
  padding-left: 8px;
}

/* Table and Map side by side layout */
.table-map-container {
  display: flex;
  gap: 20px;
  margin: 0 auto;
  padding: 20px;
  align-items: flex-start;
}

.table-wrapper {
  flex: 1;
  min-width: 0;
}

.map-wrapper {
  flex: 0 0 350px;
  position: sticky;
  top: 20px;
}

.compact-map {
  width: 100%;
  height: 450px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Responsive: stack on smaller screens */
@media (max-width: 1200px) {
  .table-map-container {
    flex-direction: column;
  }
  
  .map-wrapper {
    flex: 0 0 300px;
    width: 100%;
    position: static;
  }
  
  .compact-map {
    height: 300px;
  }
}
</style>
